import Product from "../../bigCommerce/product/Product";
import CreateProduct from "../../bigCommerce/product/CreateProduct";
import EditProduct from "../../bigCommerce/product/EditProduct";
import React from "react";
import { useContext } from "react";
import LeftDrawer from "../LeftDrawer";
import { Route, Routes, useNavigate } from "react-router-dom";
import LogOut from "../../logout";
import Dashboard from "../../dashboard/Dashboard";
import { AdminDataContext } from "../../../useContext/AdminContext";
import ChangePassword from "../../bigCommerce/user/ChangePassword";
import CreateUser from "../../bigCommerce/user/CreateUser";
import UserList from "../../bigCommerce/user/UserList";
import BCProducts from "../../bigCommerce/product/BCProducts";
import WebhookManager from "../../bigCommerce/webhookManager/WebhookManager";
const ComponentRoute = () => {
  const { adminData } = useContext(AdminDataContext);
  return (
    <>
      <LeftDrawer>
        <Routes>
          {/* dashboard route is commented for some time  */}
          {/* <Route path="/" element={<Dashboard />} /> */}
          <Route path="/" element={<Product />} />
          <Route path="/product" element={<Product />} />
          <Route path="/products" element={<Product />} />
          <Route path="/bc-products" element={<BCProducts />} />
          <Route path="/products/create" element={<CreateProduct />} />
          <Route path="/products/edit/:productId" element={<EditProduct />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/add-user" element={<CreateUser />} />
          <Route path="/user-list" element={<UserList />} />
          <Route path="/manage-webhooks" element={<WebhookManager />} />

          <Route path="/logout" element={<LogOut />} />
        </Routes>
      </LeftDrawer>
    </>
  );
};

export default ComponentRoute;
